export default __webpack_public_path__ + "static/media/352.2398665b.svg";